<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice:</label>
                        <b-form-input v-model="filtro.codiceTipo" type="search" placeholder="Codice"> </b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione:</label>
                        <b-form-input v-model="filtro.descrizione" type="search" placeholder="Descrizione"> </b-form-input>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem; margin-top: 0.5rem; margin-bottom: -1rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("global.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>

        <template slot="table-body">
            <paperclean-configurazione-marche-list-component ref="PapercleanConfigurazioneMarcheListComponent" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"> </paperclean-configurazione-marche-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import PapercleanConfigurazioneMarcheListComponent from "../components/PapercleanConfigurazioneMarcheListComponent.vue";

export default {
    name: "PapercleanConfigurazioneDizionariListPage",
    mixins: [UtilityMixin],
    components: { SaPageLayout, PapercleanConfigurazioneMarcheListComponent },
    data() {
        return {
            filtro: {
                codice: "",
                descrizione: "",
            },
            btnNewVisible: true,
            btnBackVisible: true,
            linkback: "/home",
            pathResource: "/iva",
            pathResourceSezioni: "/dizionariosezioni",
            linkedit: "/numeratori",
            showModalLoading: false,
            sezioniOptions: [{ value: "", text: "-Seleziona Valore-" }],
            listKey: 0,
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.showModalLoading = true;
            this.$refs.PapercleanConfigurazioneMarcheListComponent.loadData(this.filtro);
        },
        onRefresh() {
            this.loadData();
        },

        onAfterLoadData() {
            this.showModalLoading = false;
        },

        onBeforeLoadData() {
            this.showModalLoading = true;
        },

        onReset() {
            this.filtro = {
                sezioneDizionario: "",
                codiceTipo: "",
                descrizioneTipo: "",
            };
            this.loadData();
        },

        onSubmit() {
            this.loadData();
        },
    },
    watch: {
        // filtro: {
        //     handler(newVal) {
        //         this.$refs.NumeratoriListComponent.filtro = newVal;
        //     },
        //     deep: true,
        // },
    },
};
</script>

<style scoped>
.sa-padding-right {
    padding-right: 1rem;
}

b-button + b-button {
    margin-left: 0.5rem;
}
</style>
